export default {"src":"/_next/static/media/OGN.c0813f6e.svg","height":18,"width":18};